<template>
  <div class="small-group">
    <div class="group-left" style="padding-bottom:100px">
    <!---->
      <div class="left-top"> 
        <div class="className">当前课程：{{obj.DisciplineName}}</div>
        <div class="back" @click="back">变更</div>
      </div>
      <!--学生列表-->
      <!-- 有分组 -->
        <div  v-if="obj.isSettingGroup"  class="card_list">
          <div :class="['card',{seletcard:item._checked}]"  v-for="(item,index) in  groupData" :key="index"  @click="getDetailedData(item,index)">
            <div class="showline">
              <div class="left_name">
                <img v-if="item.Icon" :src="item.Icon" />
                <span v-if="!item.Icon" class="aviter" :style="{background:item.Sex?'#4196ff':'#ff8c8c'}"
                    >{{ xy.showName(item.FullName) }}
                </span>
              </div>
              <div class="right_content">
                <div class="name">{{ item.FullName }}</div>
                <div class="source">{{item.Score }}</div>
              </div>
            </div>
            <div  class="selspn" v-show="item._checked"></div>
          </div>
      </div>
        <!--没有分组-->
        <div class="card_list"  v-else>
          <div :class="['card',{seletcard:item._checked}]" v-for="(item,index) in  studentData" :key="index" @click="getDetailedData(item,index)">
            <div class="showline">
                <div class="left_name">
                  <img v-if="item.Icon" :src="item.Icon" />
                  <span v-if="!item.Icon" class="aviter" :style="{background:item.Sex?'#4196ff':'#ff8c8c'}"
                    >{{ xy.showName(item.FullName) }}
                  </span>
                </div>
                <div class="right_content">
                  <div class="name">{{ item.FullName }}</div>
                  <div class="source">{{item.TotalScore }}</div>
                </div>
            </div>
            <div  class="selspn" v-show="item._checked"></div>
          </div>
        </div>
    </div>
    <div class="group-right" style="padding-bottom:100px">
      <div class="right-head">
        <div class="head-title">
          <span :class="tabFlag==='often'?'active':''" @click="onTab('often')">习惯养成</span>
          <span :class="tabFlag==='all'?'active':''" @click="onTab('all')">学科素养</span>
        </div>
        <div class="recod" @click="goRecode">
          <span>评价记录</span>
        </div>
      </div>
      <!-- 全部指标 -->
       <div v-if="tabFlag==='all'"  class="setHeight" style="width:100%;position:relative">
        <div v-if="allList.length===0" class="xy-phone-no-data" style="margin:20% auto 0; width:100%">
          <img src="@/assets/basic/moblie-no-data.png" />
          <p style="font-size:14Px;">暂无指标，请添加指标。</p>
        </div>
        <div v-else v-for="(item,index) in allList" :key="index" style="width:100%;padding: 0 10px">
          <p class="level-title">{{item.IndexManagementName}}</p>
          <!--第三次改版-->
          <div class="group-wrap">
            <div :class="['group-content',{seletGroup:item1.Checked}]" v-for="(item1,index1) in item.Childrens" :key="index1" @click="check(index,index1,item1)">
              <div class="group-title">
                {{item1.IndexManagementName}}
              </div>
              <div class="operat">
                <van-rate @change="onChange(index,index1,'rate')" v-if="item1.SocringMethod===1"  :count="item1.MaxValue" v-model="item1.DefaultValue" color="#ffd21e" void-icon="star" void-color="#eee" :size="26" />
                <div class="min-max" v-if="item1.SocringMethod===0" >
                  <span>{{item1.MinValue}}分</span>
                  <van-slider @change="onChange(index,index1,'slider')" :min="item1.MinValue" :max="item1.MaxValue" v-model="item1.DefaultValue" bar-height="10px" active-color="#4196FF">-->
                    <!-- <template #button>
                      <div class="custom-button"> 
                        {{ item1.DefaultValue }}
                      </div>
                    </template> -->
                    <template #button>
                      <div class="seekBar">
                        <div class="bubble">{{item1.DefaultValue}} </div>
                      </div>
                    </template>
                  </van-slider>
                  <span>{{item1.MaxValue}}分</span>
                </div>
              </div>
              <div  class="selspn" v-show="item1.Checked"></div>
            </div>
          </div>  
        </div>
      </div>
      <!-- 常用指标 -->
      <div v-if="tabFlag==='often'" class="setHeight">
        <div v-if="oftenList.length===0" class="xy-phone-no-data" style="margin:20% auto 0; width:100%">
          <img src="@/assets/basic/moblie-no-data.png" />
          <p style="font-size:14Px;">暂无指标，请添加指标。</p>
        </div>
        <div  class="often-wrap">
          <div  v-for="(item,index) in  oftenList"  :key="index" :class="['often-item',{seletGroup:item.Checked}]" @click="check(index,'',item)" >
            <img :src="item.img" alt="">
            <span>{{item.IndexManagementName}}</span>
            <div  class="selspn2" v-show="item.Checked"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="group-bottom">
      <div class="select-all">
        <van-checkbox v-model="checkedAll" shape="round" @click="selectedAll"></van-checkbox>
        <span>全选学生</span>
      </div>
      <div class="conser-btn"  @click="confirm" v-if="obj.isEdit">保存</div>
    </div>
  </div>
</template>
<script>
  import { Toast } from 'vant';
  export default {
    name: '',
    components: {},
    data () {
      return {
        checkedAll:false,//全选
        current:null,
        card: {},
        noData:false,
        noDataOften:false,
        noDataAll:false,
        num:'1',
        scoreTotal:'1',
        allList:[],
        oftenList:[],
        options:[],
        tabFlag:"often",
        obj:{},
        show:'indexList',
        studentData:[],
        groupData:[],
        Scores:[],//选中的指标
        pickedArr:[],
        showBtn:true,
        isDummp:true,
        imgList:[
          require("./img/already.png"),
          require("./img/class.png"),
          require("./img/handup.png"),
          require("./img/pen.png"),
          require("./img/right.png"),
          require("./img/say.png"), 
          require("./img/team.png"),
          require("./img/update.png"),
        ]
        // imgArr:[
        //   ``
        // ]
      }
    },
    watch:{
      num:{
        handler(val){
          this.scoreTotal= val.toString()
        },
        deep:true,
        immediate:true,
      }
    },
    created () {
      this.obj = this.$store.state.evaluation.ipadAverageObj
      this.fetchCommUsedList()
      // this.choose()
      if(this.obj.isSettingGroup){
        this.getStudentDatahas()
      }else{
        this.getStudentDatano()
      }
    },
    mounted () {},
    methods : {
      check(index,index1 =null,item){
        item.Checked  = this.isDummp? true:!item.Checked // 点击全部还是改变星星数量
        if(this.tabFlag==='all'){
          this.$set(this.allList[index].Childrens[index1],'Checked',item.Checked)
        }else if(this.tabFlag==="often"){
        this.$set(this.oftenList[index],'Checked',item.Checked)
        }
        this.isDummp =  false
      },
      onChange(index,index1=null,type){
        if(this.tabFlag==='all'){
          this.allList[index].Childrens[index1].Checked =  true
        }else{
          this.oftenList[index].Checked  = true
        }
        this.isDummp  = type === 'rate'?true:false
      },
      onTab(data){
        this.tabFlag=data
        if(data==="all"){
          this.fetchAllList()
        }else if(data==="often"){
          this.fetchCommUsedList()
        }
      },
      // 获取常用指标列表
      async fetchCommUsedList(){
           Toast.loading({
            message: '加载中...',
            duration:3500,
            className: 'ipad_toast',
            forbidClick: true
          })
          let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetPublicIndex`, {
            schoolDistrictID: this.obj.SchoolDistrictID,
            academicSessionID: this.obj.AcademicSessionID,
            academicYearID: this.obj.AcademicYearID,
            studentGradeForStudentYearID: this.obj.StudentGradeForStudentYearID,
            disciplineID: this.obj.DisciplineID
          })
          Toast.clear();
          if (res.success) {
            this.oftenList=[]
            if (res.data.length > 0) {
              this.showBtn=true
              var j = 0
              res.data.map((i,index)=>{
                i.Checked = false
                if(index>this.imgList.length-1){
                  if(j>this.imgList.length-1){
                    j=0
                  }
                  res.data[index].img = this.imgList[j]
                  j++
                }else{
                   res.data[index].img = this.imgList[index]
                }
               
              })
              this.oftenList=res.data
            }else{
              this.showBtn=false
            }
          }
      },
      getArray(array,index){
        return  array.slice(index, index += this.imgList.length)
      },
      // 获取全部指标列表
      async fetchAllList(){
        Toast.loading({
          message: '加载中...',
          duration:3500,
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetDisciplineIndex`, {
          schoolDistrictID: this.obj.SchoolDistrictID,
          academicSessionID: this.obj.AcademicSessionID,
          academicYearID: this.obj.AcademicYearID,
          studentGradeForStudentYearID: this.obj.StudentGradeForStudentYearID,
          disciplineID: this.obj.DisciplineID
        })
        Toast.clear();
        if (res.success) {
          this.allList=[]
          if (res.data.length > 0) {
            this.showBtn=true
            res.data.map(i=>{
              i.Checked = false
            })
            this.allList=res.data
          }else{
            this.showBtn=false
          }
        }
      },

      // 保存
      async confirm(){
        this.Scores = []
         if(this.tabFlag==='all'){
          this.allList.forEach(item=>{
            if(item.Childrens.length!==0){
              item.Childrens.forEach(item1=>{
                if(item1.Checked){
                  this.Scores.push({ IndexManagementID: item1.IndexManagementID, Value: item1.DefaultValue })
                }
              })
            }
          })
        }else if(this.tabFlag === 'often'){
          this.oftenList.forEach(item=>{
            if(item.Checked){
              this.Scores.push({ IndexManagementID: item.IndexManagementID, Value: item.DefaultValue })
            }
          })
        }
          if(this.Scores.length<=0)
          {
            Toast({className: 'ipad_toast',message: '请选择指标并打分。'})
            return false
           }
            if(this.pickedArr.length<=0)
          { 
            Toast({className: 'ipad_toast',message: '请选择学生。'})
            return false
           }
        let params = {
          ClassTableGenerateBaseID: this.obj.ClassTableGenerateBaseID,
          DisciplineID: this.obj.DisciplineID,
          CoursePlanAID: this.obj.CoursePlanAID,
          CoursePlanAIDType: this.obj.CoursePlanAIDType,
          Scores: this.Scores,
          UserID: this.pickedArr
        }
         Toast.loading({
          message: '加载中...',
          duration:0,
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/EvaluateStudent/UpdataStudentScore`, params, true)
        Toast.clear();
        if (res.success) {
          Toast.success({message: res.msg || '保存成功。',className: 'ipad_toast'})
          setTimeout(() => {
            this.show = 'indexList'
            if(this.tabFlag==="all"){
              this.fetchAllList()
            }else if(this.tabFlag==="often"){
              this.fetchCommUsedList()
            }
          }, 1000);
          this.pickedArr =  []
          // 提交后清空选中的学生
          if(this.obj.isSettingGroup){
            this.getStudentDatahas()
          }else{
            this.getStudentDatano()
          }
        }else{
          Toast.fail({message: res.msg || '保存失败。',className: 'ipad_toast'})
        }
      },
      // 获取学生列表 无分组
      async getStudentDatano () {
        let params = {
          coursePlanAID: this.obj.CoursePlanAID,
          classTableGenerateBaseID: this.obj.ClassTableGenerateBaseID,
          coursePlanAIDType: this.obj.CoursePlanAIDType,
          studentOrganizationID: this.obj.StudentOrganizationID,
        }
         Toast.loading({
          message: '加载中...',
          duration:3500,
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetStudentScoreList`, params)
        if (res.success) {
          this.studentData = []
          if (res.data.length > 0) {
            this.studentData = res.data
            // console.log("学生",this.sdutentData)
          }else{
            this.noData=true
          }
        }
        Toast.clear();
      },
      // 有分组
      async getStudentDatahas(){
         Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/GradeAndClassStatistics/GetGroupAndStudentScoreInfo`, {
          schoolDistrictID: this.obj.SchoolDistrictID,
          academicSessionID: this.obj.AcademicSessionID,
          groupType:'1',
          coursePlanAID:this.obj.CoursePlanAID,
          coursePlanAIDType:this.obj.CoursePlanAIDType,
          classTableGenerateBaseID:this.obj.ClassTableGenerateBaseID,
          studentOrganizationID:this.obj.StudentOrganizationID,
        })
        Toast.clear();
        if (res.success) {
          this.groupData=[]
          if (res.data.length > 0) {
            res.data.forEach(item=>{
                  if(item.StudentScoreInfo.length!==0){
                    item.StudentScoreInfo.forEach(item1=>{
                      item1._checked=false
                      this.groupData.push(item1)
                    })
                  }
            })
          }else{
            this.noData=true
          }
        }
      },
      // 选择学生
      getDetailedData(item,index){
        item._checked = !item._checked
        this.pickedArr=[]
        if(this.obj.isSettingGroup){
          this.groupData.map(item=>{
              if(item._checked){
                this.pickedArr.push(item.UserID)
              }else{
                item._checked = false
              }
          })        
          if(this.pickedArr.length === this.groupData.length){
            this.checkedAll=true
          }else{
            this.checkedAll=false
          }
          this.updateDraft(this.groupData[index],item._checked)
        }else{
          this.studentData.map(item=>{
              if(item._checked){
                this.pickedArr.push(item.UserID)
              }else{
                item._checked = false
              }
          })        
          if(this.pickedArr.length ===  this.studentData.length ){
            this.checkedAll=true
          }else{
            this.checkedAll=false
          }
           this.updateDraft(this.studentData[index],index,item._checked)
        }       
      },
      updateDraft (tableData, index, field) {
        const obj = Object.assign({}, tableData[index])
        this.$set(tableData, index, {})
        for (var key in field) {
          obj[key] = field[key]
        }
        this.$set(tableData, index, obj)
      },
     
    // 全选
      selectedAll(){
        this.pickedArr=[]
        if(this.obj.isSettingGroup){
         this.groupData.forEach(item=>{
           item._checked =  this.checkedAll

            // item.StudentScoreInfo.map(i=>{
              // i._checked = this.checkedAll
              // if(i._checked){
                // this.pickedArr.push(i.UserID)
              // }
            // })
             if(this.checkedAll){
                this.pickedArr.push(item.UserID)
            }else{
              this.pickedArr=[]
            }
          })
         
        }else{
          this.studentData.forEach(item=>{
            item._checked = this.checkedAll
            if(this.checkedAll){
              this.pickedArr.push(item.UserID)
            }else{
              this.pickedArr=[]
            }
         })
        } 
      },
      back(){
        this.$router.go(-1)
        this.$store.commit('evaluation/setChangeClass',false)
      },
      goRecode(){
         this.$router.push({
            path:'/ipad/EvaRecode'
          })
      }
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-checkbox__icon{
  font-size: 22px;
}
 /deep/ .van-cell{
  padding:0 10px;
}
/deep/ .van-field__control{
  font-size: 100% !important;
}
/deep/ .van-slider{
  width:60%;
  height: 3px;
}
.seekBar {
    width: 30px;
    height: 30px;
    background: url(./img/score.png) no-repeat;
    background-size:100% 100%;
    position: relative;
    .bubble {
      width: 100%;
      height: 100%;
      //background: url(./img/bubble.png) no-repeat;
      color: #1677FF;
      font-size: 16Px;
      text-align: center;
      //line-height: 30px;
      position: absolute;
      //left: -5px;
      //top: -36px;
      top: 0;
      left:0;
    }
  }
  .cards{
    background: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      >p{
        font-size: 18Px;
        font-weight: 700;
        margin:20px 0 18px 20px;
        width:40%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      >div{
        >span{
          font-size: 14Px;
          color:rgba(26,26,26,0.65);
          margin-right:10px;
          span{
            font-size: 18Px;
            color:#E28D30 ;
          }
        }
      }
    }
  }
.avatar{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding:0 20px;
}
.min-max{
  display: flex;
  justify-content: space-between;
  align-items: center;
  span{
    color:#999999;
  }
}
.custom-button {
  width: 30px;
  color: #fff;
  font-size: 10Px;
  line-height: 15px;
  text-align: center;
  background-color: #4196FF;
  border-radius: 100px;
  padding-top:3px;
}
.head {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    text-align: left;
    border-radius: 50%;
    // background: @blue;
    font-size: 14Px;
    color: #fff;
    > img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 50%;
    }
  }
.heads{
  width:60%;
  margin-right:10px;
  font-size: 16px;
  color: rgba(26,26,26,0.85);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

}
.small-group{
  padding:10px;
  // padding-bottom:100px;
  display:flex;
}
 .group-left{
    width:315px;
    background: #ffffff;
    height:600px;
    overflow: auto;
    .left-top{
      margin: 19px 0;
      display: flex;
      padding: 0 20px 0 10px;
      justify-content: space-between;
      .className{
        font-size: 16px;
        font-weight: 500;
        color: rgba(0,0,0,0.85);
      }
      .back{
       font-size: 17px;
        font-weight: 500;
        text-align: center;
        color: #1677ff;
      }
    }
  }

   .group-right{
     height:600px;
      flex:1;
     background: #fff;
     margin-left:10px;
     .right-head{
      display: flex;
      padding: 17px 20px;
      justify-content: space-between;
      .head-title{
        font-size: 17px;
        font-weight: 400;
        color: rgba(0,0,0,0.35);
         & :first-child{
           margin-right:40px;
        }
        .active{
          color: #1677FF;
        }
      }

      .recod{
        font-size: 17px;
        font-weight: 400;
        color: #1677ff;
      }
     }
  }
  .setHeight{
    height: calc( 100% - 60px);
    overflow: auto;
    position: relative;
  }
  .level-title{
    font-size: 20px;
    margin: 3px 0 ;
  }
   .group{
    display: flex;
   
    align-items: center;
    margin-bottom:10px;
     border:1px solid #d5d5d5;
    border-radius: 4px;
    .left{
      width:5%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 24px;
    }
    .right{
      width:95%;
      height: 90px;
      background: #fff;
      padding: 15px;
      font-size: 16Px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .content{
        display: flex;
       
        justify-content: space-between;
        align-items: center;
        margin-right: 30px;
        .heads{
           width:365px;
           margin-right:30px
        }
      }
    }
  }



 .group-bottom{
    position: fixed;
    bottom:0;
    left: 0;
    right:0;
    height: 70px;
    border-top: 1px solid #eee;
    box-shadow: -1px 1px 4px 0px rgba(171,171,171,0.5);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding:0 30px;
    background: #fff;
    display:flex;
    justify-content: space-around;
    span{
     color: #1677FF; 
    }
    .select-all{
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: rgba(0,0,0,0.85);
      display: flex;
      span{
        margin-left:13px;
        color:rgba(0,0,0,0.85);
      }
    }
    .conser-btn{
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #267dff;
      border-radius: 40px;
      color:#fff;
      font-size: 14px;
      padding:0 23px;
    }
    
  }
  .singer{
     background: #fff;
  }
.card_list{
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  padding: 0 22px  0 10px;
}
.card {
  width: 126px;
  height: 90px;
  box-sizing: border-box;
  background: white;
  border-radius: 4px;
  margin: 5px  0;
  border: 1px white solid;
  position: relative;
}

.seletcard{
  border: 1px #1677FF solid;

}
.showline {
  height: 100%;
  line-height: 93px;
  background: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  display: flex;
}
.left_name {

  img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    vertical-align: top;
    margin-top: 29px;
    margin-left:10px;
    
  }
  .aviter {
    display: inline-block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    vertical-align: top;
    margin-top: 29px;
    margin-left:10px;
    background: #4196ff;
    line-height: 36px;
    // prettier-ignore
    font-size: 14Px;
    color: white;
    text-align: center;
   
  }
  
}
.right_content{
  flex:1;
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 0 8px;
  .name {
    // prettier-ignore
   font-size: 16px;
   font-family: PingFangSC, PingFangSC-Medium;
   font-weight: 500;
   text-align: center;
   color: rgba(0,0,0,0.85);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    line-height: 24px;
  }
  
}
.source {
  font-size: 26px;
  color: rgba(226,141,48,1);
  line-height: 24px;
  margin-top: 5px;
}
.selspn {
  width: 31px;
  height: 31px;
  background: url('./img/sel.png');
  background-size: 62px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.selspn2{
  width: 31px;
  height: 31px;
  background: url('./img/sel.png');
  background-size: 62px;
  position: absolute;
  bottom: 0px;
  right: 0px; 
}
.group-wrap{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.often-wrap{
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px 0 15px;
}
.often-item{
  width: 112px;
  height: 90px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px 9px;
  position: relative;
}
.often-item span{
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Medium;
  margin-top: 5px;
  display: inline-block;
}
.often-item img{
  width: 42px;
  height: 42px;
}
.group-content{
   width: 49%;
   height:80px;
   border: 1px solid #ccc;
   margin: 5px 0;
   padding: 10px 10px 5px ;
   position: relative;
   .group-title{
      width: 100%;
      height:36px;
      line-height:18px;
      font-size: 16px;
      color: rgba(26,26,26,0.85);
      overflow: hidden;
      text-overflow:ellipsis;    
      //white-space: nowrap;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
   }
   .operat{
     font-size: 16px;
     width: 50%;
     height: 30px;
     line-height: 30px;
   }
   .selspn{
     background: url('./img/sel.png');
     background-size: 62px;
     position: absolute;
     bottom: 0px;
     right: 0px;
   }
}
.seletGroup{
  border: 1px solid #1677ff;
}
</style>
